import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { PlusCircleFill } from "react-bootstrap-icons";
import { HiArrowSmallLeft } from "react-icons/hi2";

interface PollData {
    id: number,
    question: string,
    optionCount: number
}

const PollData = () => {
  const { id } = useParams<{ id: string }>();
  const [pollData, setPollData] = useState<PollData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchPollData = async () => {
      try {
        const response = await postDetails(APIList.GETALL_TRAININING_CONTENT, { training_id: Number(id) });
        console.log(response)
        if (response.data && Array.isArray(response.data)) {
            const aggregatedlivepollData: PollData[] = response.data.flatMap((item: any) => item.livepollData || []);
          
            if (aggregatedlivepollData.length > 0) {
                setPollData(aggregatedlivepollData);
              } else {
                setError("No Poll Data found.");
              }
            } else {
              setError("No Poll Data found.");
            }
          } catch (err) {
            setError("Failed to fetch Quiz data.");
            console.error("Error fetching Quiz data:", err);
          } finally {
            setLoading(false);
          }
        };

    fetchPollData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const columns: TableColumn[] = [
    // { key: "id", label: "id", sortable: true },
    { key: "question", label: "Question", sortable: true,dataType:"string" },
    { key: "optionCount", label: "Option Count", sortable: true },
  ];
  const handleAddNewTraining = () => {
    navigate(`/trainings`); 
  
  };
  
  const buttons = [
    {
      label: "Back to Training",
      theme: "warning",
      icon: <HiArrowSmallLeft />,
      onClick: handleAddNewTraining,
    },
  ]

  return (
   
    <LayoutContainer title={"Training"}>
    <div>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-dashboard"></i>
          Poll Data
        </h2>

        <PageHeader buttons={buttons} />
      </div>
      <CommonTable<PollData>
        data={pollData}
        columns={columns}
        pagination={true}
        rowsPerPage={10}
        actions={{
          view: false,
          edit: false,
          delete: false,
          checkbox: false,
          status: false,
          showModal: false,
        }}
      />
    </div>
      </LayoutContainer>
  );
};

export default PollData;